// The sections of the one-page terminal (/app), in scroll order. NavBar shows them as centre tabs.
export const SECTIONS = [
  { id: "chart", label: "Chart" },
  { id: "marketdepth", label: "Market Depth" },
  { id: "python", label: "Python" },
  { id: "backtest", label: "Backtest" },
];
export const NAV_HEIGHT = 56;

/** Smooth-scroll to a section of the /app page; false when it is not on this page. */
export function scrollToSection(id) {
  const el = typeof document !== "undefined" ? document.getElementById(id) : null;
  if (!el) return false;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
}
